// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1HL-a","selects":"Documents_selects__-UOny"};